// QuickBlox SDK is loaded from CDN (deferred script in public/index.html, executed
// before the app bundle) to keep ~2MB out of the main bundle.
export const prepareQBSDK = (QBConfig) => {
  const QB = window.QB;
  if (!QB) {
    throw new Error("QuickBlox SDK failed to load");
  }

  const { appId, authKey, authSecret, accountKey } = QBConfig.credentials;
  QB.init(appId, authKey, authSecret, accountKey, QBConfig.appConfig);
  return QB;
};
